
// TODO: if Backend API is updated to return image_bg_slug in the event's flyer field, this can be removed
// This table maps flyer design numbers to their corresponding image_bg_slug.
// Used as the default flyer image when the event detail page flyer is still in the default state.
export const VideoFlyerBackgrounds = {
  // example: 'design_number': 'image_bg_slug'
  '1': 'flyer_background_palms_001',
  '2': 'flyer_background_flowers_002',
  '3': 'flyer_background_bottles_003',
  '4': 'flyer_background_beer_004',
  '5': 'flyer_background_ocean_005',
  '7': 'flyer_background_balloons_007',
  '9': 'flyer_background_bunting_008',
  '11': 'flyer_background_sunflower_010',
  '15': 'flyer_background_birthday_014',
  '17': 'flyer_background_chalk_016',
  '20': 'flyer_background_milk_jug_019',
  '23': 'flyer_background_balloons_007',
  '25': 'flyer_background_city_023',
  '32': 'flyer_background_sandwich_board_030',
  '33': 'flyer_background_live_music_031',
  '34': 'flyer_background_vintage_coffee_032',
  '35': 'flyer_background_action_sports_033',
  '36': 'flyer_background_convertible_034',
  '37': 'flyer_background_sparkler_two_035',
  '38': 'flyer_background_ferris_wheel_036',
  '39': 'flyer_background_water_jug_037',
  '40': 'flyer_background_cupcake_two_038',
  '41': 'flyer_background_disco_ball_two_039',
  '42': 'flyer_background_martini_two_040',
  '43': 'flyer_background_stadium_two_041',
  '44': 'flyer_background_whiskey_two_042',
  '45': 'flyer_background_coals_two_043',
  '46': 'flyer_background_pool_044',
  '47': 'flyer_background_confetti_two_045',
  '48': 'flyer_background_pumpkin_two_046',
  '49': 'flyer_background_wreath_047',
  '50': 'flyer_background_snowy_branches_048',
  '51': 'flyer_background_champagne_049',
  '53': 'flyer_background_string_lights_051',
  '54': 'flyer_background_modern_cafe_052',
  '55': 'flyer_background_camping_053',
  '56': 'flyer_background_palms_two_054',
  '57': 'flyer_background_clover_055',
  '58': 'flyer_background_ranunculus_056',
  '59': 'flyer_background_easter_eggs_057',
  '60': 'flyer_background_baby_feet_058',
  '61': 'flyer_background_bicycle_059',
  '62': 'flyer_background_wine_060',
  '63': 'flyer_background_harvest_061',
  '64': 'flyer_background_spooky_062',
  '65': 'flyer_background_pine_branch_063',
  '66': 'flyer_background_pumpkin_three_064',
  '67': 'flyer_background_winter_065',
  '68': 'flyer_background_berries_066',
  '69': 'flyer_background_fall_leaves_067',
  '70': 'flyer_background_scattered_white_068',
  '71': 'flyer_background_figs_069',
  '72': 'flyer_background_monsterra_070',
  '73': 'flyer_background_architecture_071',
  '74': 'flyer_background_rainbow_rose_072',
  '75': 'flyer_background_gold_cocktails_073',
  '76': 'flyer_background_scattered_blue_074',
  '77': 'flyer_background_peony_075',
  '78': 'flyer_background_astronaut_076',
  '79': 'flyer_background_purple_disco_077',
  '80': 'flyer_background_guacamole_078',
  '81': 'flyer_background_vintage_palms_079',
  '82': 'flyer_background_gifts_080',
  '83': 'flyer_background_birthday_cake_081',
  '84': 'flyer_background_confetti_toss_082',
  '85': 'flyer_background_city_bokeh_083',
  '86': 'flyer_background_confetti_yay_084',
  '87': 'flyer_background_floral_frame_white_085',
  '92': 'flyer_background_sparkler_3_090',
  '93': 'flyer_background_scattered_3_091',
  '94': 'flyer_background_leaves_092',
  '96': 'flyer_background_cupcake_3_094',
  '97': 'flyer_background_palms_2_095',
  '98': 'flyer_background_stadium_3_096',
  '99': 'flyer_background_martini_3_097',
  '100': 'flyer_background_baby_mobile_098',
  '101': 'flyer_background_baby_layflat_white_099',
  '102': 'flyer_background_baby_layflat_color_100',
  '103': 'flyer_background_old_fashioned_101',
  '104': 'flyer_background_cake_and_plates_102',
  '105': 'flyer_background_dino_disco_103',
  '106': 'flyer_background_manly_confetti_104',
  '107': 'flyer_background_brunch_table_105',
  '108': 'flyer_background_floral_frame_black_106',
  '109': 'flyer_background_2019_balloons_107',
  '110': 'flyer_background_2019_tassle_108',
  '111': 'flyer_background_prom_flat_lay_109',
  '112': 'flyer_background_bbq_flames_110',
  '113': 'flyer_background_pool_floaties_111',
  '114': 'flyer_background_ocean_drone_112',
  '115': 'flyer_background_christmas_wreath_115',
  '116': 'flyer_background_christmas_ornament_116',
  '117': 'flyer_background_christmas_board_117',
  '118': 'flyer_background_ocean_sunset_118',
  '119': 'flyer_background_flower_pink_119',
  '120': 'flyer_background_crystal_120',
  '121': 'flyer_background_concert_pink_121',
  '122': 'flyer_background_concert_blue_122',
  '123': 'flyer_background_fire_123',
  '124': 'flyer_background_prism_124',
  '125': 'flyer_background_splash_125',
  '126': 'flyer_background_forest_126',
  '127': 'flyer_background_lake_127',
  '128': 'flyer_background_flower_white_128',
  '129': 'flyer_background_grad_caps_129',
  '130': 'flyer_background_cake_and_candle_130',
  '131': 'flyer_background_football_field_131',
  '132': 'flyer_background_candy_hearts_132',
  '133': 'flyer_background_water_133',
  '134': 'flyer_background_wood_siding_134',
  '135': 'flyer_background_wildflowers_135',
  '136': 'flyer_background_hot_air_ballons_136',
  '137': 'flyer_background_cupcakes_137',
  '138': 'flyer_background_swirl_138',
  '139': 'flyer_background_disco_ball_139',
  '140': 'flyer_background_woods_140',
  '141': 'flyer_background_window_141',
  '142': 'flyer_background_pink_peacock_142',
  '143': 'flyer_background_sporty_skeleton_143',
  '144': 'flyer_background_skull_144',
  '145': 'flyer_background_pumpkin_patch_145',
  '146': 'flyer_background_pumpkin_head_146',
  '147': 'flyer_background_football_147',
  '148': 'flyer_background_assorted_pumpkins_148',
  '149': 'flyer_background_thanksgiving_potluck_149',
  '150': 'flyer_background_leaves_150',
  '151': 'flyer_background_toy_car_151',
  '152': 'flyer_background_xmas_tree_152',
  '153': 'flyer_background_holiday_lights_153',
  '154': 'flyer_background_velvet_154'
}
